const GERMAN_DICTIONARY = {
  "No records found": "Keine Datensätze gefunden",
  "Showing page {0} of {1} entries": "Seite {0} von {1} Einträgen",
  "Show ": "Anzeigen ",
  "Search": "Suchen",
  " entries": " Einträge",
  "Column name": "Spaltenname",
  "Insert a new column before": "Neue Spalte davor einfügen",
  "Insert a new column after": "Neue Spalte danach einfügen",
  "Delete selected columns": "Ausgewählte Spalten löschen",
  "Rename this column": "Diese Spalte umbenennen",
  "Order ascending": "Aufsteigend sortieren",
  "Order descending": "Absteigend sortieren",
  "Insert a new row before": "Neue Zeile davor einfügen",
  "Insert a new row after": "Neue Zeile danach einfügen",
  "Delete selected rows": "Ausgewählte Zeilen löschen",
  "Edit comments": "Kommentare bearbeiten",
  "Add comments": "Kommentare hinzufügen",
  "Comments": "Kommentare",
  "Clear comments": "Kommentare löschen",
  "Copy...": "Kopieren...",
  "Paste...": "Einfügen...",
  "Save as...": "Speichern unter...",
  "About": "Über",
  "Are you sure to delete the selected rows?": "Ausgewählte Zeilen wirklich löschen?",
  "Are you sure to delete the selected columns?": "Ausgewählte Spalten wirklich löschen?",
  "This action will destroy any existing merged cells. Are you sure?":
    "Diese Aktion löscht alle vorhandenen verbundenen Zellen. Wirklich fortfahren?",
  "This action will clear your search results. Are you sure?":
    "Diese Aktion löscht Ihre Suchergebnisse. Wirklich fortfahren?",
  "There is a conflict with another merged cell":
    "Es besteht ein Konflikt mit einer anderen verbundenen Zelle",
  "Invalid merge properties": "Ungültige Eigenschaften für verbundene Zellen",
  "Cell already merged": "Zelle ist bereits verbunden",
  "No cells selected": "Keine Zellen ausgewählt",
};

export function configureJssGermanLocale(jspreadsheet) {
  jspreadsheet.setDictionary(GERMAN_DICTIONARY);
}
